import router from '../router'
import axios, { AxiosError } from 'axios'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
})

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token@lifeadmin')

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

api.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      localStorage.removeItem('token@lifeadmin')
      localStorage.removeItem('user@lifeadmin')

      router.push({ name: 'login' })

      throw new AxiosError('Não autenticado!')
    }

    return response
  },
  (error) => {
    return Promise.reject(error)
  },
)
